module.exports = __webpack_public_path__ + "static/media/measurement-goal.15cb8321.svg";